import styled from "styled-components"

export const EnterManuallyButtonWrapper = styled.div`
  bottom: 0;
  border-radius: 100px;
  border: 1px solid rgba(255, 255, 255, 0.36);

  background: var(--Primitive-White_10, rgba(255, 255, 255, 0.1));
  backdrop-filter: blur(5.25px);

  display: flex;
  padding: 12px 20px;
  align-items: center;
  gap: 8px;

  width: 228px;
  cursor: pointer;
`

export const GalleryButtonWrapper = styled.div`
  border-radius: 100px;

  background: var(--Primitive-White_10, rgba(255, 255, 255, 0.1));
  backdrop-filter: blur(5.25px);

  display: flex;
  padding: 12px;
  align-items: center;
  justify-content: center;

  width: 48px;
  height: 48px;
  cursor: pointer;

  /* Touch-friendly minimum size for mobile */
  min-width: 44px;
  min-height: 44px;
`

export const EnterManuallyText = styled.span`
  font-size: 14px;
  font-weight: 700;
  line-height: 160%;
  color: var(--Primitive-White_100, #fff);
`

export const CloseButton = styled.div`
  position: absolute;
  left: 19px;
  top: 10px;
  cursor: pointer;
  width: 24px;
  height: 24px;
`

export const BottomCtaBox = styled.div`
  padding: var(--spacing_xl, 24px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;

  border-top: 1px solid rgba(255, 255, 255, 0.54);
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.4) 0%,
    rgba(0, 0, 0, 0.12) 100%
  );
  backdrop-filter: blur(5px);

  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
`

export const HeaderSection = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: var(--spacing_xl, 24px);
  display: flex;
  gap: 12px;
  align-items: center;
  z-index: 10;
  padding-top: 44px;
  pointer-events: none;
`

export const HeaderContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--spacing_xxs, 4px);
`

export const HeaderTitle = styled.h1`
  font-family: "Proxima Nova", sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 1.2;
  color: #ffffff;
  margin: 0;
`

export const HeaderSubtitle = styled.div`
  display: flex;
  gap: 3px;
  align-items: baseline;
`

export const HeaderSubtitleText = styled.span`
  font-family: "Proxima Nova", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.8);
  white-space: nowrap;
`

export const HeaderBadge = styled.span`
  display: inline-flex;
  padding: 2px 4px;
  border-radius: 2px;
  background: rgba(0, 38, 58, 0.32);
  font-family: "Proxima Nova", sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
  color: #ffffff;
  white-space: nowrap;
`

export const HeaderImage = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
